module.exports = __webpack_public_path__ + "static/media/pollutionb.d3256231.jpg";